import React from 'react';
import { connect } from 'react-redux';

import OtherGoodsItem from './OtherGoodsItem';
import CustomizedTabs from '../../../components/Tabs/Tabs';
import s from './OtherGoods.module.scss';

const OtherGoods = props => {
  const { id, goods, t } = props;

  const renderItem = data => {
    if (!data) return null;
    const goodData = data.locData[t.language];
    if (!goodData) return null;
    return (
      <OtherGoodsItem
        key={data.id}
        id={data.id}
        image={data.img}
        name={goodData.name}
        description={goodData.description_preview}
        price={data.cost}
        t={t}
      />
    );
  };

  const related = goods[id].supplemental
    .map(goodId => goods[goodId])
    .map(i => renderItem(i));

  const similar = goods[id].similar
    .map(goodId => goods[goodId])
    .map(i => renderItem(i));

  const data = [];
  if (related.length) {
    data.push({
      title: t['С этим товаром покупают'],
      content: related,
      id: 'related-tab-catalog'
    });
  }
  if (similar.length) {
    data.push({
      title: t['Похожие товары'],
      content: similar,
      id: 'similar-tab-catalog'
    });
  }

  return (
    <CustomizedTabs name="tabpanel-1" data={data} className={s.OtherGoods} />
  );
};

const mapStateToProps = state => ({
  goods: state.goods,
  t: state.translation
});

export default connect(mapStateToProps)(OtherGoods);
